import React from "react";
import { Phone, Facebook, Instagram, MapPin, Clock } from "lucide-react";
import { BUSINESS, TOWNS } from "../../lib/constants";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="bg-navy-dark text-white relative overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          {/* Brand */}
          <div className="md:col-span-5">
            <div className="flex items-center gap-4">
              <img
                src={BUSINESS.logo}
                alt="B&C Junk Removal Pros"
                data-testid="footer-logo"
                className="h-20 w-20 object-contain"
              />
              <div>
                <p className="font-display uppercase text-2xl leading-tight">
                  B&amp;C Junk <br /> Removal Pros
                </p>
                <p className="mt-1 text-white/60 text-xs uppercase tracking-[0.25em]">
                  Syracuse · New York
                </p>
              </div>
            </div>
            <p className="mt-6 text-white/75 max-w-md">
              Fast, friendly, fully insured junk removal and light demolition —
              serving Syracuse and 50 miles around, every day of the week.
            </p>

            <div className="mt-6 flex flex-col gap-2 text-white/80">
              <a
                href={BUSINESS.phoneHref}
                data-testid="footer-call-btn"
                className="inline-flex items-center gap-3 font-display uppercase text-gold hover:text-white transition-colors"
              >
                <Phone className="h-4 w-4" strokeWidth={3} />
                {BUSINESS.phoneDisplay}
              </a>
              <span className="inline-flex items-center gap-3 text-sm">
                <Clock className="h-4 w-4 text-gold" strokeWidth={2.5} />
                {BUSINESS.hours}
              </span>
              <span className="inline-flex items-center gap-3 text-sm">
                <MapPin className="h-4 w-4 text-gold" strokeWidth={2.5} />
                Syracuse, NY · 50-mile service radius
              </span>
            </div>
          </div>

          {/* Service Area */}
          <div className="md:col-span-4">
            <p className="font-body text-xs uppercase tracking-[0.25em] text-gold mb-5">
              Service Area
            </p>
            <ul className="grid grid-cols-2 gap-y-2 text-white/80 text-sm">
              {TOWNS.map((t) => (
                <li key={t} className="flex items-center gap-2">
                  <span className="h-1.5 w-1.5 bg-gold" />
                  {t}
                </li>
              ))}
            </ul>
          </div>

          {/* Connect */}
          <div className="md:col-span-3">
            <p className="font-body text-xs uppercase tracking-[0.25em] text-gold mb-5">
              Connect
            </p>
            <div data-testid="footer-social-links" className="flex items-center gap-3">
              <a
                href={BUSINESS.facebook}
                target="_blank"
                rel="noreferrer"
                data-testid="footer-facebook"
                aria-label="Facebook"
                className="h-12 w-12 inline-flex items-center justify-center border-2 border-white/40 hover:bg-gold hover:border-gold hover:text-navy transition-colors"
              >
                <Facebook className="h-5 w-5" />
              </a>
              <a
                href={BUSINESS.instagram}
                target="_blank"
                rel="noreferrer"
                data-testid="footer-instagram"
                aria-label="Instagram"
                className="h-12 w-12 inline-flex items-center justify-center border-2 border-white/40 hover:bg-gold hover:border-gold hover:text-navy transition-colors"
              >
                <Instagram className="h-5 w-5" />
              </a>
            </div>
            <a
              href="#quote"
              className="mt-6 inline-flex items-center justify-center gap-2 bg-gold text-navy px-5 py-3 font-display uppercase tracking-wider text-sm border-2 border-gold hover:bg-white transition-colors"
            >
              Free Quote
            </a>
          </div>
        </div>

        <div className="mt-16 pt-6 border-t border-white/15 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-white/60 text-xs uppercase tracking-[0.2em]">
          <span>© {new Date().getFullYear()} B&amp;C Junk Removal Pros. All rights reserved.</span>
          <span>RN-Owned · Minority-Owned · Fully Insured</span>
        </div>
      </div>

      {/* Giant faint tagline */}
      <div className="pointer-events-none select-none overflow-hidden">
        <p className="font-display uppercase text-white/5 text-[18vw] leading-[0.85] whitespace-nowrap text-center -mb-6">
          Syracuse Strong.
        </p>
      </div>
    </footer>
  );
};
